<template>
    <div class="frmteendok_formcont" v-show="TEENDOK.length>0">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"></GrcDialog>

        <grccms_accordion cms_stylename="accordion_lavenderblush" cms_opened="false" style="margin-bottom:20px;">
            <template slot="acc_header">
                <div style="width:100%; color:var(--colorMain8);">
                    <i class="fal fa-clipboard-list-check" style="font-size: 32px; vertical-align: middle; display: inline-block; width: 50px;"></i>
                    <b>{{Title}}</b>
                </div>
            </template>
            <template slot="acc_content">
                <div style="width:100%; box-sizing:border-box;margin:0px;padding:0px;">
                    
                    <div class="frmteendok_item_cont" v-for="(item,index) in TEENDOK" :key="index">
                        <div class="frmteendok_item_szoveg" v-html="item.Szoveg"></div>
                    </div>

                    
                </div>
            </template>
        </grccms_accordion>


    </div>
</template>

<script>

import Vue from 'vue'
import { setTimeout } from 'timers';
import { clearTimeout } from 'timers';

import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import grccms_accordion from '../GrcComponents/grccms_accordion.vue'

export default {
  name: 'frmteendok',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
      grccms_accordion
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmteendok_",

          InitDone:false,  

          TEENDOK:[],
          Title:"Teendők"

      }
  },
  model: {

  },  
  methods:{

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmteendok", pCompName);
    },

    SetLang()
    {

        this.Init();
    },


    SetControlToFocus(pNextComp)
    {
      if (pNextComp == "") { return; }
      this.$refs[pNextComp].SetFocus();
    },

      async Init()
      {
        this.InitDone = false;

        var QP = { 
            sSESSIONID: "[APPSESSIONID]"
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Init", QP).then(res => { Q = res; });


        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.Title = Q.MISC[0].Title;
        this.TEENDOK = Q.TEENDOK;

        this.InitDone = true;

      },

    async ShowResult(pText, pHeight)
    {
        var DialogResult = "";
        //await this.$refs.Dialog.Alert("Információ",pText).then(res => { DialogResult = res; });  
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = 20;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => { DialogResult = res; });               
    },



  },
  created()
  {

  },
  mounted()
  {
    //console.log("mount");
    this.SetLang();
    
  }

}


</script>


